var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOutOfSpecIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1372_675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6666C4.31816 14.6666 1.3335 11.6819 1.3335 7.99992C1.3335 4.31792 4.31816 1.33325 8.00016 1.33325C11.6822 1.33325 14.6668 4.31792 14.6668 7.99992C14.6668 11.6819 11.6822 14.6666 8.00016 14.6666ZM8.35378 6.70351C8.1585 6.89886 7.84182 6.89886 7.64655 6.70351L6.46838 5.52493C6.27313 5.32961 5.9565 5.32958 5.76121 5.52487L5.52511 5.76097C5.32983 5.95626 5.32985 6.27289 5.52517 6.46814L6.70376 7.6463C6.8991 7.84158 6.8991 8.15826 6.70376 8.35353L5.52518 9.5317C5.32985 9.72695 5.32983 10.0436 5.52511 10.2389L5.76121 10.475C5.9565 10.6703 6.27313 10.6702 6.46838 10.4749L7.64655 9.29633C7.84182 9.10098 8.1585 9.10098 8.35378 9.29633L9.53194 10.4749C9.72719 10.6702 10.0438 10.6703 10.2391 10.475L10.4752 10.2389C10.6705 10.0436 10.6705 9.72695 10.4752 9.5317L9.29657 8.35354C9.10123 8.15826 9.10122 7.84158 9.29657 7.6463L10.4752 6.46814C10.6705 6.27289 10.6705 5.95626 10.4752 5.76097L10.2391 5.52487C10.0438 5.32958 9.72719 5.32961 9.53194 5.52493L8.35378 6.70351Z",
    fill: "#E63559"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1372_675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOutOfSpecIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/OutOfSpecIcon.ce986610.svg";
export { ForwardRef as ReactComponent };